'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextareaWrapper = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _formField = require('../form-field');
var _formField2 = _interopRequireDefault(_formField);
var _controlField = require('../../hocs/control-field');
var _controlField2 = _interopRequireDefault(_controlField);
var _textarea = require('./textarea');
var _constants = require('../../constants');
var _propTypes = require('prop-types');
var _lodash = require('lodash');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var TextareaWrapper = exports.TextareaWrapper = function (_Component) {
  _inherits(TextareaWrapper, _Component);
  function TextareaWrapper() {
    _classCallCheck(this, TextareaWrapper);
    return _possibleConstructorReturn(this, (TextareaWrapper.__proto__ || Object.getPrototypeOf(TextareaWrapper)).apply(this, arguments));
  }
  _createClass(TextareaWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        error = _props.error,
        label = _props.label,
        name = _props.name,
        helpText = _props.helpText,
        disabled = _props.disabled,
        fieldCss = _props.fieldCss,
        textarea = _props.textarea,
        extra = _props.extra,
        rest = _objectWithoutProperties(_props, ['error', 'label', 'name', 'helpText', 'disabled', 'fieldCss', 'textarea', 'extra']);
      return _react2.default.createElement(_formField2.default, {
        label: label,
        error: error,
        name: name,
        helpText: helpText,
        disabled: disabled,
        css: fieldCss,
        extra: extra
      }, textarea(Object.assign({}, rest, {
        name: name,
        error: error
      })));
    }
  }]);
  return TextareaWrapper;
}(_react.Component);
TextareaWrapper.propTypes = Object.assign({}, _constants.fieldPropTypes, {
  textarea: _propTypes.func
});
TextareaWrapper.defaultProps = Object.assign({}, _constants.defaultFieldPropTypes, {
  value: '',
  textarea: function textarea(_ref) {
    var name = _ref.name,
      validate = _ref.validate,
      control = _ref.control,
      error = _ref.error,
      validating = _ref.validating,
      rest = _objectWithoutProperties(_ref, ['name', 'validate', 'control', 'error', 'validating']);
    return _react2.default.createElement(_textarea.Textarea, Object.assign({
      name: name,
      onBlur: validate,
      onChange: control,
      validating: validating,
      valid: typeof error !== 'undefined' ? !error.length : undefined
    }, (0, _lodash.omit)(rest, _constants.omitProps)));
  }
});
exports.default = (0, _controlField2.default)(TextareaWrapper);